import { TechnicianScheduleResponse } from 'services/technicianSchedule/types'
import { formatDate, formatTime } from 'domains/serviceOrders/utilities'
import { Icon, IconButton } from 'components'
import styles from './styles.module.scss'

interface ScheduleBlockCard {
  schedule: TechnicianScheduleResponse
  onEdit: () => void
}

const ScheduleBlockCard = ({ schedule, onEdit }: ScheduleBlockCard) => (
  <li className={styles.card}>
    <header>
      {formatDate(schedule.startDate) + ' às ' + formatTime(schedule.startDate)}
      <span>até</span>
      {formatDate(schedule.endDate) + ' às ' + formatTime(schedule.endDate)}
      <IconButton onClick={onEdit} className={styles.editButton}>
        <Icon name="edit" />
      </IconButton>
    </header>
    <p>{schedule.note}</p>
  </li>
)

export default ScheduleBlockCard
